import { render, staticRenderFns } from "./index.vue?vue&type=template&id=47fd1578&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=47fd1578&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fd1578",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent03/user/3333/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47fd1578')) {
      api.createRecord('47fd1578', component.options)
    } else {
      api.reload('47fd1578', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=47fd1578&scoped=true&", function () {
      api.rerender('47fd1578', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project/atoms/DataDisplayField/index.vue"
export default component.exports